import { inject, Injectable, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { Nullable } from '@ps/utils';
import { CompanyDetail, CompanyFormMode } from '../models/company.model';
import {
  selectError,
  selectIsDeleting,
  selectIsLoadingDetail,
  selectIsSaving,
  selectMode,
  selectSelectedCompany,
} from './company.selectors';

@Injectable({ providedIn: 'root' })
export class CompanyDetailSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly mode: Signal<CompanyFormMode> =
    this._store.selectSignal(selectMode);
  public readonly selectedCompany: Signal<Nullable<CompanyDetail>> =
    this._store.selectSignal(selectSelectedCompany);
  public readonly isSaving: Signal<boolean> =
    this._store.selectSignal(selectIsSaving);
  public readonly isDeleting: Signal<boolean> =
    this._store.selectSignal(selectIsDeleting);
  public readonly isLoadingDetail: Signal<boolean> = this._store.selectSignal(
    selectIsLoadingDetail,
  );
  public readonly error: Signal<Nullable<string>> =
    this._store.selectSignal(selectError);
}
